import { render, staticRenderFns } from "./BiK.vue?vue&type=template&id=c9bec5fa&"
import script from "./BiK.vue?vue&type=script&lang=js&"
export * from "./BiK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports